import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: "fa",
    backend: {
      loadPath: "/assets/lang/{{lng}}/{{ns}}.json",
    },
    fallbackLng: ["en", "fa"],
    debug: false,
    ns: [
      "naroon","home","footer","property"
    ],
    checkWhitelist: true,
    order: [
      "querystring",
      "cookie",
      "localStorage",
      "navigator",
      "htmlTag",
      "path",
      "subdomain",
    ],
    lookupQuerystring: "lng",
    lookupCookie: "i18next",
    lookupLocalStorage: "i18nextLng",
    lookupFromPathIndex: 0,
    lookupFromSubdomainIndex: 0,
    caches: ["localStorage", "cookie"],
    excludeCacheFor: ["cimode"],
    cookieMinutes: 10,
    cookieDomain: "myDomain",
  });

export default i18n;
